import { render, staticRenderFns } from "./StockAlarmModal.vue?vue&type=template&id=72434641&scoped=true"
import script from "./StockAlarmModal.vue?vue&type=script&lang=js"
export * from "./StockAlarmModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72434641",
  null
  
)

export default component.exports